import { Box } from '@mui/material';
import { CerebroPill } from './CerebroPill';

// Like a partial React.ChangeEvent because formik falls back to handling any value it receives on change as an event if it isn't a string.
export interface CerebroYesNoChangeEvent {
	target: {
		name: string;
		value: boolean;
	};
}

interface CerebroYesNoProps {
	small?: boolean;
	name: string;
	error?: boolean;
	disabled?: boolean;
	value: boolean | null;
	onChange: (event: CerebroYesNoChangeEvent) => void;
}

export const CerebroYesNo: React.FC<CerebroYesNoProps> = ({
	small,
	name,
	error = false,
	disabled = false,
	value,
	onChange,
}) => {
	const onClick = (newValue: boolean) => {
		// Only call the onChange if the value is actually changing.
		if (newValue !== value) onChange({ target: { name, value: newValue } });
	};

	return (
		<Box
			sx={{
				marginBottom: 1,
				marginTop: 1.5,
			}}
		>
			<CerebroPill
				small={small}
				error={error}
				disabled={disabled}
				selected={value === true}
				onClick={() => onClick(true)}
				sx={{ marginRight: 3 }}
			>
				Yes
			</CerebroPill>
			<CerebroPill
				small={small}
				error={error}
				disabled={disabled}
				selected={value === false}
				onClick={() => onClick(false)}
			>
				No
			</CerebroPill>
		</Box>
	);
};
